import { shopScene } from '../shopkit.js';

/** 瓦舍：听书、吃酒、掷骰子，天一黑这里就活了。 */
export const funRoomDoc = shopScene({
  id: 'fun_room',
  name: '瓦舍',
  shop: 'fun_room',
  owner: '班主',
  desc: '台上唱着，台下猜着拳，声音能掀翻屋顶。',
  w: 24, h: 18,
  counters: [{ gx: 9, gy: 3, len: 5, kind: 'fun_room' }],
  props: [
    { type: 'storyteller_table', gx: 6, gy: 9 },
    { type: 'dining_table', gx: 10, gy: 12 },
    { type: 'dining_table', gx: 13, gy: 12 },
    { type: 'gambling_mat', gx: 17, gy: 13 },
    { type: 'liquor_flag', gx: 20, gy: 6 },
    { type: 'notice_board', gx: 4, gy: 15 },
  ],
  portals: [
    { to: 'fun_street', gx: 12, gy: 17, spawn: [7, 10], label: '回瓦舍街' },
  ],
});

export default funRoomDoc;
